export default "__VITE_ASSET__CeZizqyb__"